import * as React from 'react';
import { SVGProps } from 'react';

const SvgSupportGroups = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M25.655 24.83H5.687v-2.22h19.968c1.633 0 7.14-3.9 10.565-6.691a1.11 1.11 0 0 0-.031-1.535 1.131 1.131 0 0 0-1.571 0l-.044.04c-1.127 1.011-6.91 6.043-10.055 6.043h-6.58a3.408 3.408 0 0 1-3.408-3.004 3.329 3.329 0 0 1 3.336-3.652h5.591a1.11 1.11 0 0 0 1.065-1.233 1.145 1.145 0 0 0-1.176-.985h-6.589c-.174 0-.346.04-.501.12l-6.42 3.243h-4.15v-2.219h3.621l5.946-3.008a3.408 3.408 0 0 1 1.504-.355h6.607a3.377 3.377 0 0 1 3.377 3 3.331 3.331 0 0 1-3.315 3.638h-5.586a1.113 1.113 0 0 0-1.11 1.22 1.171 1.171 0 0 0 1.198.999h6.594c1.686 0 6.013-3.186 8.555-5.458a3.329 3.329 0 1 1 4.686 4.73l-.084.075c-8.427 6.905-11.493 7.25-12.025 7.25Z"
    />
    <path
      fill={props.fill}
      d="M5.687 12.685H1.272L1.25 26.032l4.402 4.398.035-17.745Z"
    />
  </svg>
);

export default SvgSupportGroups;
